import React from 'react';
import ReactDOM from 'react-dom';

import { BaseApp } from './BaseApp';

import './index.css';

ReactDOM.render(
  <BaseApp />,
  document.getElementById('root')
);